import _ from 'lodash'
import Backbone from 'backbone'
import template from './update-license.hbs'
import FormView from 'scoreboard/components/form-view'
import FileDrop from 'scoreboard/components/files/file-drop'

var UpdateLicenses = Backbone.View.extend({

	// this.license is the license

	tagName: 'form',

	className: 'update-license',

	initialize: function(options) {
		this.options = options || {}
		this.license = options.license
		this.fileDrop = new FileDrop({
			fileUploaderOptions: {
				url: 'api/admin/licenses'
			}
		})
		this.formView = new FormView({ el: this.el })
	},

	render: function() {
		this.$el.empty().append(template(this.license))
		this._renderFileDrop()
		this.formView.start()
		this._attachListeners()
		return this
	},

	_renderFileDrop() {
		this.$('.file-drop').replaceWith(this.fileDrop.el)
		this.fileDrop.render()
	},

	_attachListeners() {
		this.fileDrop.on('done', data => this.trigger('done', data))
			.on('error', err => this.uploadError(err))
	},

	uploadError: function(xhr) {
		this.formView.error(xhr)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.fileDrop], 'remove')
	}

})

export default UpdateLicenses

UpdateLicenses.__filename__ = 'admin/licenses/update-license.js'
